import { PropsWithChildren } from 'react'

import { Typography } from '@maistodos/design-system-web'

type SectionTextProps = PropsWithChildren<{
  className?: string
}>

export const SectionText = ({ className = '', children }: SectionTextProps) => (
  <Typography className={className} variant="medium" color="neutral600">
    {children}
  </Typography>
)
